import React, { Component } from 'react';
import { connect } from 'react-redux';
import { 
    Switch,
    Route,
    Link,
    Redirect
} from 'react-router-dom';
import { Layout, Menu, Icon } from 'antd';
import Loadable from 'react-loadable';

import Logout from '../Logout';
import Breadcrumbs from '../Breadcrumbs';
import Spinner from '../Spinner';
import PrivateRoute from '../../utils/privateRoute';

const LoadingAsync = ({ error, pastDelay }) => {
    if (error) {
        return <div>Sorry, there was a problem loading the page.</div>;
    } else if (pastDelay) {
        return <Spinner />;
    } else {
        return null;
    }
}

const AsyncLogin = Loadable({
    loader: () => import ('../Login'),
    loading: LoadingAsync
});

const AsyncQRReader = Loadable({
    loader: () => import('../QRReader'),
    loading: LoadingAsync
});


const AsyncGuestData = Loadable({
    loader: () => import('../GuestData'),
    loading: LoadingAsync
});

const AsyncGuestEdit = Loadable({
    loader: () => import('../GuestEdit'),
    loading: LoadingAsync
});

const AsyncAllGuests = Loadable({
    loader: () => import('../AllGuests'),
    loading: LoadingAsync
});

const AsyncStats = Loadable({
    loader: () => import('../Stats'),
    loading: LoadingAsync
})

const { Header, Content } = Layout;

class App extends Component {
    renderMain() {
        return (    
            <Switch>
                <Route exact path="/login" component={AsyncLogin} />
                <Redirect exact from="/" to="/guests" />
                <PrivateRoute path="/reader" component={AsyncQRReader} />

                <PrivateRoute path="/guests/page/:page" component={AsyncAllGuests} />
                <PrivateRoute path="/guests/:id/edit" component={AsyncGuestEdit} />
                <PrivateRoute path="/guests/:id" component={AsyncGuestData} />
                <PrivateRoute path="/guests" component={AsyncAllGuests} />
                
                <PrivateRoute path="/stats" component={AsyncStats} />

                <PrivateRoute path="/logout" component={Logout} />
            </Switch>
        );
    }

    render() {
        const { location, isLoading, loginedIn } = this.props;

        return (
            <Layout>
                <Header style={{padding: '0 20px', backgroundColor: '#D5172A'}}>
                    <h1 style={{color: '#fff'}}>UXID</h1>
                </Header>

                <Content style={{ padding: '0 20px' }}>
                    <Route component={Breadcrumbs} />
                </Content>

                {loginedIn && (
                    <Content>
                        <Menu 
                            mode="horizontal"
                            selectedKeys={[location.pathname]}
                        >
                            <Menu.Item key="/guests">
                                <Link to="/guests"><Icon type="contacts" />All Guests</Link>
                            </Menu.Item>
                            <Menu.Item key="/reader">
                                <Link to="/reader"><Icon type="qrcode" />QR Reader</Link>
                            </Menu.Item>
                            <Menu.Item key="/stats">
                                <Link to="/stats"><Icon type="table" />Stats</Link>
                            </Menu.Item>
                            
                            <Menu.Item key="/logout">
                                <Link to="/logout"><Icon type="logout" />Logout</Link>
                            </Menu.Item>
                        </Menu>
                    </Content>
                )}

                <Content style={{ padding: '20px' }}>
                    <div style={{ background: '#fff', padding: '20px' }}>
                        {isLoading ?
                            <Spinner /> :
                            this.renderMain()
                        }
                    </div>
                </Content>
            </Layout>
        );
    }
}

const mapStateToProps = ({ app, auth }) => {
    const { isLoading } = app;
    const { loginedIn } = auth;

    return {
        isLoading,
        loginedIn,
    };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/index.js